<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="店铺名称">
        <el-input
          v-model="query.shop_name"
          placeholder="店铺名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="所属合作商">
        <cooperatorSelect
          :clearable="true"
          :condition="{ type: 'shop' }"
          :coopid.sync="query.coop_id"
          :info="coopName"
        ></cooperatorSelect>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择" clearable>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="营业中" :value="1"></el-option>
          <el-option label="已关闭" :value="2"></el-option>
          <el-option label="已禁用" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #status="{ row }">
        <el-tag size="small" type="info" v-if="row.status === 0">待审核</el-tag>
        <el-tag size="small" type="success" v-if="row.status === 1"
          >营业中</el-tag
        >
        <el-tag size="small" type="warning" v-if="row.status === 2"
          >已关闭</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 3"
          >已禁用</el-tag
        >
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="update(row)"
          >编辑</el-button
        >
        <el-button size="small" type="primary" @click="details(row)"
          >详情</el-button
        >
        <el-button
          v-if="row.status === 0 || row.status === 2"
          size="small"
          type="success"
          @click="updateStatus(row, 1)"
          >开启营业</el-button
        >
        <el-button
          v-if="row.status === 1"
          size="small"
          type="warning"
          @click="updateStatus(row, 2)"
          >关闭店铺</el-button
        >
        <el-button
          v-if="row.status !== 3"
          size="small"
          type="danger"
          @click="updateStatus(row, 3)"
          >禁用</el-button
        >
        <el-button
          v-if="row.status === 3"
          size="small"
          type="success"
          @click="updateStatus(row, 1)"
          >解禁</el-button
        >
      </template>
    </auto-table>
    <AddorEdit
      @success="getList"
      ref="AddorEdit"
      :coopId="query.coop_id"
    ></AddorEdit>
  </div>
</template>

<script>
import AddorEdit from "./components/AddorEdit.vue";
import cooperatorSelect from "@/components/select/cooperatorSelect.vue";

export default {
  components: {
    AddorEdit,
    cooperatorSelect,
  },
  data() {
    return {
      nav: { firstNav: "合作商管理", secondNav: "店铺列表" },
      DataList: [],
      query: {
        shop_name: "",
        coop_id: "",
        status: "",
      },
      coopName: "",
      Option: [
        { name: "店铺编号", value: "shop_no" },
        { name: "店铺名称", value: "shop_name" },
        { name: "所属合作商", value: "coop_name" },
        { name: "行业", value: "industry" },
        { name: "联系电话", value: "contact_phone" },
        { name: "地址", value: "address" },
        { name: "状态", value: "status", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "340px" },
      ],
      Total: 0,
    };
  },

  mounted() {
    //从合作商列表进入，带合作商筛选
    if (this.$route.query.coop_id) {
      this.query.coop_id = Number(this.$route.query.coop_id);
      this.coopName = this.$route.query.coop_name || "";
    }
    this.getList(1);
  },

  methods: {
    details(row) {
      this.$router.push({
        name: "shopDetails",
        query: { id: row.id },
      });
    },
    add() {
      this.$refs.AddorEdit.open();
    },
    update(row) {
      this.$refs.AddorEdit.open(row);
    },
    updateStatus(row, status) {
      const tips = {
        1: "开启营业",
        2: "关闭店铺",
        3: "禁用",
      };
      this.$confirm(`确定${tips[status]}该店铺吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            url: "/user/shop/update",
            data: {
              id: row.id,
              status,
            },
            method: "post",
          }).then((res) => {
            this.$notify({
              message: "操作成功",
              duration: 2000,
              type: "success",
            });
            this.getList(1);
          });
        })
        .catch(() => {});
    },

    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/shop/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          shop_name: this.query.shop_name || null,
          coop_id: this.query.coop_id || null,
          status: this.query.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
